// removed by extract-text-webpack-plugin
module.exports = {"container":"Column__container___1_6KR","cards-container":"Column__cards-container___1q7Gu"};